import type {
  OneOfExpression,
  OperationExpression,
} from '@rtkwlf/asset-data-service';

export const operation = (
  operator: OperationExpression['operator'],
  ...args: OperationExpression['arguments']
): Pick<OneOfExpression, 'operation'> => ({
  operation: {
    operator,
    arguments: args,
  },
});

export const field = (name: string): Pick<OneOfExpression, 'field'> => ({
  field: { name },
});

export const scalar = (value: string): Pick<OneOfExpression, 'scalar'> => ({
  scalar: { value },
});

export const list = (values: string[]): Pick<OneOfExpression, 'list'> => ({
  list: values.map((value) => ({ value })),
});

export const and = (...args: OperationExpression['arguments']) =>
  operation('and', ...args);

export const like = (name: string, value: string) =>
  operation('like', field(name), scalar(value));

export const any = (name: string, values: string[]) =>
  operation('any', field(name), list(values));

export const lte = (name: string, value: string) =>
  operation('lte', field(name), scalar(value));

export const gte = (name: string, value: string) =>
  operation('gte', field(name), scalar(value));

export const range = (name: string, from: string, to: string) =>
  and(gte(name, from), lte(name, to));

export const isnull = (name: string) => operation('isnull', field(name));
